import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { grabarEstadoCotizacion } from '../../../../service/AffariService';
import CabeceraCliente from '../CabeceraCliente';

export const EstadosDialog = ({ visible, onCancel, estados, cotizacion, detalles, toast, onRefresh }) => {
    const [estadoSeleccionadoCabecera, setEstadoSeleccionadoCabecera] = useState(null);
    const [selectedDetalles, setSelectedDetalles] = useState(null);
    const [detallesEstados, setDetallesEstados] = useState({});
    const [loadingGrabar, setLoadingGrabar] = useState(false);

    useEffect(() => {
        setEstadoSeleccionadoCabecera(cotizacion?.estado?.id ?? null);
        setSelectedDetalles(null);
        setDetallesEstados({});
    }, [cotizacion?.estado?.id, detalles]);

    const handleGrabar = async () => {
        setLoadingGrabar(true);
        if (!cotizacion?.id) return;

        const id = cotizacion.id;
        const id_estado = estadoSeleccionadoCabecera;
        const detallesSeleccionados = Array.isArray(selectedDetalles) ? selectedDetalles : [];

        const id_detalles = detallesSeleccionados
            .map((d) => d.id)
            .filter((v) => v !== undefined && v !== null);

        const id_estados = detallesSeleccionados
            .map((d) => {
                const estadoDetalle = detallesEstados[d.id];
                return estadoDetalle ?? d.estado ?? id_estado;
            })
            .filter((v) => v !== undefined && v !== null);

        try {
            await grabarEstadoCotizacion(id, id_detalles, id_estado, id_estados);

            if (toast && toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Éxito',
                    detail: 'Estados grabados correctamente',
                });
            }
            if (onRefresh) {
                onRefresh();
            }
            onCancel();
        } catch (error) {
            console.error('Error grabando estado de cotización:', error);
            if (toast && toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Error grabando estados de cotización',
                });
            }
        } finally {
            setLoadingGrabar(false);
        }
    };

    return (
        <Dialog 
            header={`Estados de Cotización Folio: ${cotizacion?.folio || ''}`}
            visible={visible} 
            className="custom-dialog" 
            onHide={onCancel}
        >
            <div className="card">
                <CabeceraCliente cotizacion={cotizacion} />
                
                <div className="mb-3 border-top-1 surface-border pt-3">
                    <span className="text-600 font-medium mr-2">Estado</span>
                    <Dropdown 
                        value={estadoSeleccionadoCabecera} 
                        options={estados} 
                        optionLabel="descripcion" 
                        optionValue="id"
                        className="p-inputtext-sm"
                        onChange={(e) => setEstadoSeleccionadoCabecera(e.value)}
                        disabled={loadingGrabar}
                    />
                </div>
                <div className="mb-3 border-top-1 surface-border pt-3">
                    <DataTable 
                        value={detalles} 
                        size="small"
                        showGridlines
                        dataKey="id"
                        selectionMode="checkbox"
                        selection={selectedDetalles}
                        onSelectionChange={(e) => setSelectedDetalles(e.value)}
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                        <Column header="cantidad" field="cantidad" />
                        <Column header="Artículo" field="codigo" />
                        <Column header="descripcion" field="glosa" />
                        <Column header="UM" field="unidad" />
                        <Column header="Precio" field="precioLista" />
                        <Column header="Desc." field="descuento" />
                        <Column header="Total" field="total" />
                        <Column 
                            header="Estado"  
                            body={(rowData) => {
                                const isSelected = Array.isArray(selectedDetalles)
                                    && selectedDetalles.some((item) => item.id === rowData.id);

                                const value = detallesEstados[rowData.id] ?? rowData.estado ?? estadoSeleccionadoCabecera ?? null;

                                return (
                                    <Dropdown 
                                        value={value} 
                                        options={estados} 
                                        optionLabel="descripcion" 
                                        optionValue="id"
                                        className="p-inputtext-sm"
                                        disabled={!isSelected || loadingGrabar}
                                        onChange={(e) => {
                                            setDetallesEstados((prev) => ({
                                                ...prev,
                                                [rowData.id]: e.value,
                                            }));
                                        }}
                                        
                                    />
                                );
                            }}
                        />
                    </DataTable>
                    <Button 
                        label="Grabar" 
                        className="mt-3" 
                        icon={loadingGrabar ? "pi pi-spin pi-spinner" : "pi pi-save"} 
                        onClick={handleGrabar}
                        disabled={loadingGrabar}
                    />
                </div>
            </div>
        </Dialog>
    );
};